import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { ShipmentFiltersService } from './shipment-filters.service';
import { ShipmentFiltersInitialState, ShipmentFiltersLoad, ShipmentFiltersUpdate } from './shipment-filters.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { ShipmentFilterName } from '../constants';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentFiltersStateModel {
  items: ShipmentFilterName[];
  loaded: boolean;
}

const initialState: ShipmentFiltersStateModel = { items: [], loaded: false };

@State<ShipmentFiltersStateModel>({
  name: 'shipmentFilters',
  defaults: initialState,
})
@Injectable()
export class ShipmentFiltersState {
  constructor(
    private shipmentFiltersService: ShipmentFiltersService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: ShipmentFiltersStateModel): ShipmentFiltersStateModel {
    return state;
  }
  @Selector()
  static getItems(state: ShipmentFiltersStateModel): ShipmentFilterName[] {
    return state.items;
  }
  @Selector()
  static getLoaded(state: ShipmentFiltersStateModel): boolean {
    return state.loaded;
  }

  @Action(ShipmentFiltersLoad)
  getShipmentFilters(ctx: StateContext<ShipmentFiltersStateModel>): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentFiltersService.getShipmentFilters().pipe(
      map((filters: ShipmentFilterName[]) => {
        ctx.patchState({ items: filters, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentFiltersUpdate)
  updateShipmentFilters(
    ctx: StateContext<ShipmentFiltersStateModel>,
    { payload }: ShipmentFiltersUpdate,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentFiltersService.updateShipmentFilters(payload).pipe(
      map((filters: ShipmentFilterName[]) => {
        ctx.patchState({ items: filters, loaded: true });
        this.notificationService.success('api.transportFilters.success.update');
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentFiltersInitialState)
  setInitialState(ctx: StateContext<ShipmentFiltersInitialState>): void {
    ctx.setState(initialState);
  }
}
